import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import {
  useGetEmployeeByContainerIdQuery,
  useGetHrDepartmentsQuery,
  useGetSingleCommitteQuery,
} from "../../../../../../api/hrApi";
import DashboardStyle from "../../../../../../dashboard/Styles/Dashboard.module.css";
import {
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
} from "../../../../../Components/Forms/InputTemplate";
import people from "../../../../../Images/grad.svg";
import { useEffect } from "react";
const EditCommitteeIndexModal = ({
  isOpen,
  setIsOpen,
  onValidate = () => {},
  openNext = (rev) => rev,
  id,
  cachedData = null,
}) => {
  const { data: department, isLoading } = useGetHrDepartmentsQuery({
    PageSize: 1000,
    PageNumber: 1,
  });
  const formMethods = useForm({
    mode: "all",
  });
  const {
    handleSubmit,
    formState: { isValid },
    watch,
    reset,
  } = formMethods;
  const departmentId = watch("departmentId");
  const { data } = useGetEmployeeByContainerIdQuery(departmentId);
  const { data: details } = useGetSingleCommitteQuery(id);
  useEffect(() => {
    // Prioritize cached data over API data
    if (cachedData) {
      reset(cachedData);
    } else if (details?.responseObject) {
      reset({
        title: details?.responseObject?.title?.toString() || "",
        description: details?.responseObject?.description?.toString() || "",
        departmentId: parseInt(details?.responseObject?.departmentId) || 0,
        committeeHeadId: parseInt(details?.responseObject?.committeeHeadId) || 0,
      });
    }
  }, [details, reset, cachedData]);
  const submit = (data) => {
    if (
      !data.title ||
      !data.description ||
      !data.departmentId ||
      !data.committeeHeadId
    ) {
      console.error("Please fill in all required fields");
      return;
    }
    onValidate(data);
    openNext(data);
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up </h4>
          <h1 className="text-[28px] font-[800]">Edit Committee</h1>
          <p>Define and manage committee setup.</p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <FormInput
                title={"Committee Title"}
                camelCase={"title"}
                placeholder={"select"}
              />
              <FormTextArea
                className="h-[200px]"
                title={"Commitee Description"}
                camelCase={"description"}
              />
              <div className="border-1 rounded-md p-2 mt-2 border-[#A0BDA2]">
                <FormSelect
                  title={"Department"}
                  camelCase={"departmentId"}
                  placeholder={"select"}
                  array={department?.responseObject?.pageItems?.map((opt) => (
                    <option key={opt.value} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                  defaultValue={0}
                />
                <FormSelect
                  title={"Committee Head"}
                  camelCase={"committeeHeadId"}
                  placeholder={"select"}
                  array={data?.result?.map((opt) => (
                    <option key={opt.value} value={opt.id}>
                      {opt.firstName} {opt.surname}
                    </option>
                  ))}
                  defaultValue={0}
                />
              </div>
              <div className="flex justify-between my-4">
                <div className="w-2" />
                <button
                  type="submit"
                  className="bg-[#18BB0C1A] text-[#18BB0C] px-5 py-2 rounded-sm flex items-center space-x-2"
                >
                  <img src={people} alt="people grag icon" />{" "}
                  <span>Add Member</span>
                </button>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default EditCommitteeIndexModal;
